import React, { useRef } from 'react';
import EmailSubscription from './EmailSubscription';
import WhyCognitva from './WhyCognitva';
import WhyNow from './WhyNow';
import Testimonials from './Testimonials';
import RequestInfo from '../RequestInfo/RequestInfo';
import './HomeSection.css';
import featureFlags from '../../configuration/featureFlags';
import Divider from '../VerticalsWePower/Divider';
import { Helmet } from 'react-helmet-async';
import siteConfig from '../../configuration/siteConfiguration';
import FeaturePlanet from '../FeaturePlanet';
import { competencyPills4LargeScreen, competencyPills4SmallScreen } from './features-data';

const HomeSection = () => {
  const sectionRef = useRef(null);
  const isScreenSmall = window.innerWidth < 1150;

  const competencyPills = isScreenSmall ? competencyPills4SmallScreen : competencyPills4LargeScreen;


  const renderPill = (pill, index) => (
    <div key={index} className="competency-pill">
      <span className="competency-icon">
        {pill.icon}
      </span>
      {pill.text}
    </div>
  );



  return (
    <>
      <Helmet>
        <title>Cognitva - Your Enterprise-Wide Intelligence Layer</title>
        <meta name="description" content="Cognitva is your enterprise-wide intelligence layer, built on the Cross-Industry Intelligence Platform (CIP). It powers smart co-pilots, automates workflows, and predicts outcomes across every function and vertical." />
        <link rel="canonical" href="/" />
        <meta property="og:title" content="Cognitva - Your Enterprise-Wide Intelligence Layer" />
        <meta property="og:description" content="Cognitva is your enterprise-wide intelligence layer, built on the Cross-Industry Intelligence Platform (CIP). It powers smart co-pilots, automates workflows, and predicts outcomes across every function and vertical." />
        <meta property="og:image" content="/companylogo.svg" />
        <meta property="og:url" content="https://www.cognitva.ai/" />
      </Helmet>
      <section className="hero-section">
        <div className="hero-section-left">
          <div className="ellipse63-bg">
            <img src="/images/ellipse63.svg" alt="Ellipse Decorative" />
          </div>
          <div className="hero-container">
            <div className="hero-badge">
              <span className="hi-icon" role="img" aria-label="waving hand">👋</span>
              <span>Where AI Adoption Fails in Regulated Industries, Cognitva Works</span>
            </div>

            <h1 className="section_title">
              The Responsible-AI Productization Platform for Healthcare-First, Manufacturing-Proven Enterprises.
            </h1>

            <p className="hero-description">
              <strong>Cognitva turns AI pilots into governance-ready production systems.</strong><br />
              <span style={{ fontSize: "16px" }}>Built on Ideonix™ and Cognitva CIP™, we embed compliance, explainability, and domain logic directly into AI- so enterprises can deploy safely, scale confidently, and reuse intelligence across industries.</span>

            </p>

            <EmailSubscription onJumpIconClick={() => {
              console.log('Jump icon clicked');
              sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
            }} />
          </div>

        </div>
        {!isScreenSmall && <div className="hero-section-right">
          <FeaturePlanet competencyPills={competencyPills} />
        </div>}
      </section>
      {isScreenSmall &&
        <FeaturePlanet competencyPills={competencyPills} />
      }
      <div ref={sectionRef}><WhyCognitva /></div>
      <WhyNow />
      {featureFlags.home.showTestimonials ? <Testimonials /> : <Divider />}
      <RequestInfo />

    </>
  );
};

export default HomeSection; 